import React from 'react';
import ReactDOM from 'react-dom';
import { App } from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import './styles/app.scss';
import 'babel-polyfill';
import './assets/styles/vendor.scss';
import './assets/styles/main.scss';
import { getCurrentSubdomain } from './commons/domain';

// const theme = localStorage.getItem('theme');
if (getCurrentSubdomain().indexOf('gw') !== -1 || localStorage.getItem('theme') === 'gw-theme') {
    document.body.classList.add('gw-theme');
    document.title = 'Gebrüder Weiss';
    // console.log('GW theme added!');
}else{
    document.body.classList.remove('gw-theme');
    document.title = 'Deliver Me';
    localStorage.removeItem('theme');
}

ReactDOM.render(<App />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./src/index.js